import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setIsCollapsed(mobile); // collapse only if mobile
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const sidebarStyle = {
    background: 'linear-gradient(180deg, #1e293b 0%, #334155 50%, #1e293b 100%)',
    height: '100vh',
    width: isMobile ? '280px' : (isCollapsed ? '80px' : '250px'),
    maxWidth: isMobile ? '85vw' : 'none',
    boxShadow: '2px 0 20px rgba(0,0,0,0.3)',
    borderRight: '1px solid #475569',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1000,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    transform: (isMobile && isCollapsed) ? 'translateX(-100%)' : 'translateX(0)',
    display: 'flex',
    flexDirection: 'column',
    backdropFilter: 'blur(10px)'
  };

  const overlayStyle = {
    display: isMobile && !isCollapsed ? 'block' : 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    zIndex: 999,
    transition: 'opacity 0.3s ease',
    backdropFilter: 'blur(2px)'
  };

  const toggleButtonStyle = {
    position: 'fixed',
    top: isMobile ? '1rem' : '0.75rem',
    left: isMobile ? '1rem' : '2rem',
    zIndex: 2001,
    backgroundColor: '#334155',
    border: '2px solid #475569',
    borderRadius: isMobile ? '12px' : '8px',
    padding: isMobile ? '12px 14px' : '10px 12px',
    color: '#ffffff',
    cursor: 'pointer',
    boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
    transition: 'all 0.3s ease',
    fontSize: isMobile ? '1.4rem' : '1.2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: isMobile ? '48px' : '44px',
    minHeight: isMobile ? '48px' : '44px'
  };

  const navItems = [
    { to: "/portfolio", label: "Portfolio", icon: "📊" },
    { to: "/dashboard", label: "Dashboard", icon: "🏠" },
    { to: "/trade-history", label: "Holdings", icon: "💼" },
    { to: "/billing", label: "Billing Grid", icon: "💳" },
    { to: "/analyze-symbol", label: "Analyse Symbol", icon: "📈" },
    { to: "/watchlist", label: "Watchlist", icon: "👁️" },
    { to: "/decision-report", label: "Decision Report", icon: "📋" },
    { to: "/strategy-manager", label: "Strategy Manager", icon: "⚙️" }
  ];

  return (
    <>
      <div style={overlayStyle} onClick={toggleSidebar}></div>

      <button 
        onClick={toggleSidebar} 
        style={toggleButtonStyle}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#475569';
          e.target.style.transform = 'scale(1.05)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#334155';
          e.target.style.transform = 'scale(1)';
        }}
      >
        {isCollapsed ? '☰' : '✕'}
      </button>

      <div className="sidebar" style={sidebarStyle}>
        {/* Header */}
        <div style={{
          padding: isMobile ? '2rem 1.5rem 1rem' : (isCollapsed ? '1rem 0.5rem' : '1.5rem'),
          borderBottom: '1px solid #475569',
          textAlign: isCollapsed && !isMobile ? 'center' : 'left',
          flexShrink: 0,
          marginTop: isMobile ? '60px' : '0'
        }}>
          {isCollapsed && !isMobile ? (
            <div style={{
              width: '40px',
              height: '40px',
              backgroundColor: '#3b82f6',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              fontSize: '1.2rem',
              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
            }}>
              💼
            </div>
          ) : (
            <div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '0.5rem'
              }}>
                <div style={{
                  width: isMobile ? '50px' : '40px',
                  height: isMobile ? '50px' : '40px',
                  backgroundColor: '#3b82f6',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '1rem',
                  fontSize: isMobile ? '1.4rem' : '1.2rem',
                  boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                }}>
                  💼
                </div>
                <div>
                  <h4 style={{
                    color: '#ffffff',
                    fontWeight: '600',
                    margin: '0',
                    fontSize: isMobile ? '1.3rem' : '1.2rem'
                  }}>Logged In</h4>
                  <small style={{
                    color: '#94a3b8',
                    fontSize: isMobile ? '0.9rem' : '0.85rem'
                  }}>samseer mannisseri</small>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Nav Items Container with Scrollbar */}
        <div 
          className="sidebar-nav-container"
          style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: isMobile ? '1rem 0' : '0.5rem 0',
            scrollbarWidth: 'thin',
            scrollbarColor: '#475569 transparent'
          }}
        >
          <style jsx>{`
            .sidebar-nav-container::-webkit-scrollbar {
              width: 6px;
            }
            .sidebar-nav-container::-webkit-scrollbar-track {
              background: transparent;
            }
            .sidebar-nav-container::-webkit-scrollbar-thumb {
              background-color: #475569;
              border-radius: 3px;
              opacity: 0.7;
            }
            .sidebar-nav-container::-webkit-scrollbar-thumb:hover {
              background-color: #64748b;
            }
          `}</style>
          
          <ul className="nav flex-column" style={{
            padding: isMobile ? '0 1.5rem' : (isCollapsed ? '0 0.25rem' : '0 1rem'),
            listStyle: 'none',
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: isMobile ? '0.5rem' : '0.25rem'
          }}>
            {navItems.map(({ to, label, icon }) => (
              <li className="nav-item" key={to}>
                <NavLink
                  to={to}
                  className="nav-link"
                  onClick={isMobile ? toggleSidebar : undefined}
                  style={({ isActive }) => ({
                    color: isActive ? '#ffffff' : '#cbd5e1',
                    backgroundColor: isActive ? 'rgba(59, 130, 246, 0.2)' : 'transparent',
                    border: isActive ? '1px solid rgba(59, 130, 246, 0.3)' : '1px solid transparent',
                    borderRadius: isMobile ? '12px' : '8px',
                    padding: isMobile ? '1rem 1.25rem' : (isCollapsed ? '0.75rem' : '0.75rem 1rem'),
                    fontWeight: '500',
                    fontSize: isMobile ? '1rem' : '0.9rem',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: isCollapsed && !isMobile ? 'center' : 'flex-start',
                    boxShadow: isActive ? '0 4px 12px rgba(59, 130, 246, 0.15)' : 'none',
                    whiteSpace: 'nowrap',
                    position: 'relative',
                    minHeight: isMobile ? '56px' : '44px',
                    cursor: 'pointer'
                  })}
                  onMouseEnter={(e) => {
                    const link = e.target.closest('.nav-link');
                    if (!link.style.backgroundColor.includes('59, 130, 246')) {
                      link.style.backgroundColor = 'rgba(71, 85, 105, 0.5)';
                      link.style.color = '#ffffff';
                      link.style.transform = 'translateX(3px)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    const link = e.target.closest('.nav-link');
                    if (!link.style.backgroundColor.includes('59, 130, 246')) {
                      link.style.backgroundColor = 'transparent';
                      link.style.color = '#cbd5e1';
                      link.style.transform = 'translateX(0)';
                    }
                  }}
                  onTouchStart={(e) => {
                    // Better touch feedback on mobile
                    const link = e.target.closest('.nav-link');
                    if (!link.style.backgroundColor.includes('59, 130, 246')) {
                      link.style.backgroundColor = 'rgba(71, 85, 105, 0.7)';
                    }
                  }}
                  onTouchEnd={(e) => {
                    const link = e.target.closest('.nav-link');
                    if (!link.style.backgroundColor.includes('59, 130, 246')) {
                      setTimeout(() => {
                        link.style.backgroundColor = 'transparent';
                      }, 150);
                    }
                  }}
                  title={isCollapsed && !isMobile ? label : ""}
                >
                  <span style={{ 
                    marginRight: isCollapsed && !isMobile ? '0' : (isMobile ? '1rem' : '0.75rem'),
                    fontSize: isMobile ? '1.3rem' : '1.1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: isMobile ? '24px' : '20px'
                  }}>
                    {icon}
                  </span>
                  {(!isCollapsed || isMobile) && (
                    <span style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      fontWeight: isMobile ? '500' : '400'
                    }}>
                      {label}
                    </span>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        {/* Footer */}
        {(!isCollapsed || isMobile) && (
          <div style={{
            padding: isMobile ? '1.5rem' : '1rem',
            borderTop: '1px solid #475569',
            backgroundColor: 'rgba(30, 41, 59, 0.9)',
            flexShrink: 0
          }}>
            <div style={{
              backgroundColor: 'rgba(71, 85, 105, 0.4)',
              borderRadius: isMobile ? '12px' : '8px',
              padding: isMobile ? '1rem' : '0.75rem',
              color: '#cbd5e1',
              fontSize: isMobile ? '0.9rem' : '0.8rem',
              textAlign: 'center',
              border: '1px solid rgba(71, 85, 105, 0.3)'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}>
                <div style={{
                  width: '8px',
                  height: '8px',
                  backgroundColor: '#10b981',
                  borderRadius: '50%',
                  boxShadow: '0 0 8px rgba(16, 185, 129, 0.5)'
                }}></div>
                <strong style={{ color: '#ffffff' }}>Trading Status:</strong> 
                <span style={{ color: '#10b981' }}>Active</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;